"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RpcSuccess = /** @class */ (function () {
    function RpcSuccess(payload) {
        this.jsonrpc = '2.0';
        // noinspection TypeScriptValidateTypes link:https://youtrack.jetbrains.com/issue/WEB-36766
        Object.assign(this, payload);
        this.id = payload.id;
        this.result = payload.result || null;
    }
    /*
    * @deprecated use rpcSuccess.id instead
    * */
    RpcSuccess.prototype.getId = function () {
        return this.id;
    };
    /*
  * @deprecated use rpcSuccess.result instead
  * */
    RpcSuccess.prototype.getResult = function () {
        return this.result;
    };
    /*
    * @deprecated use rpcSuccess.result.headers instead
    * */
    RpcSuccess.prototype.getHeaders = function () {
        var _a;
        return (_a = this.result) === null || _a === void 0 ? void 0 : _a.headers;
    };
    return RpcSuccess;
}());
exports.default = RpcSuccess;
//# sourceMappingURL=RpcSuccess.js.map